import { useRequest } from "../../utils/api";
import { RequestConfigType } from "../../utils/api.type";
import { GetOrganisationResponseType, UserMeResponseType } from "./index.type";

const ENDPOINT_GET_ME = '/v1/rms/auth/profile/'
const ENDPOINT_GET_ORGANISATIONS = '/v1/auth/organisation/';
export const useMe = (obj = {} as RequestConfigType) => {
  return useRequest<UserMeResponseType>(ENDPOINT_GET_ME, {
    ...obj
  }, {
    enabled: obj.enabled
  })
}

export const useOrganisations = (obj = {} as RequestConfigType) => {
  return useRequest<GetOrganisationResponseType>(ENDPOINT_GET_ORGANISATIONS, {}, {
    enabled: obj.enabled
  })
}